export enum ButtonType {
 'tool' = 'tool',
 'large' = 'large',
 'regular' = 'regular',
 'pill' = 'pill'
}